import * as Reflux from "reflux";
export const OrderOptionsPanelActions = {
	onSetEgalTaxApplied: Reflux.createAction(["onSetEgalTaxApplied"]),
	onSetIgnoreFees: Reflux.createAction(["onSetIgnoreFees"]),
	onSetSendPickingListToCentralWarehouse: Reflux.createAction(["onSetSendPickingListToCentralWarehouse"]),
	onSetSendOrderConfirmationToCardholder: Reflux.createAction(["onSetSendOrderConfirmationToCardholder"]),
	onSetSendOrderConfirmationToCustomer: Reflux.createAction(["onSetSendOrderConfirmationToCustomer"]),
	onSetFiscalReceipt: Reflux.createAction(["onSetFiscalReceipt"]),
	onSetSingleInvoice: Reflux.createAction(["onSetSingleInvoice"]),
};
export type OrderOptionsPanelActionsType = typeof OrderOptionsPanelActions;
